import { useState } from 'react';
import { Link } from 'react-router-dom';
import { mapAuthError, sendPasswordReset } from '../../lib/partnerAuth';
import { usePageAnalytics } from '../../hooks/usePageAnalytics';
import { useSEO } from '../../hooks/useSEO';
import styles from './Auth.module.css';
import logo from '../../assets/images/logo.png';
import { PartnerAffiliatePromoStrip } from '../../components/partners/PartnerAffiliatePromoStrip';

export function PartnerForgotPassword() {
  usePageAnalytics();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useSEO({
    title: 'Reset Password — LuvLust Partners',
    description: 'Reset your LuvLust partner account password.',
  });

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);
    try {
      await sendPasswordReset(email);
      setSuccess(true);
    } catch (err: unknown) {
      setError(mapAuthError(err, 'Could not send reset email'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.page}>
      <PartnerAffiliatePromoStrip />
      <div className={styles.pageBody}>
        <div className={styles.card}>
          <div className={styles.logoRow}>
            <img src={logo} alt="" width={36} height={36} />
            <span className={styles.brand}>LuvLust Partners</span>
          </div>
          <h1 className={styles.title}>Reset your password</h1>
          <p className={styles.sub}>
            Enter your account email and we&apos;ll send you a link to choose a new password.
          </p>

          {error && <div className={styles.error}>{error}</div>}
          {success ? (
            <div className={styles.success}>
              Check your inbox for a password reset link. If you don&apos;t see it, check spam.
            </div>
          ) : null}

          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.field}>
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
              />
            </div>
            <button type="submit" className={styles.submit} disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>

          <p className={styles.switch}>
            <Link to="/partners/login">Back to sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
